import { Shield, Heart, Clock, Wrench, Zap } from "lucide-react";

const PILLARS = [
    {
        icon: Zap,
        title: "Instant AI pricing",
        body: "Upload a photo and get a ballpark price range in seconds — powered by Claude Vision, not a call-back queue.",
        accent: "text-electric bg-electric/10 border-electric/20",
    },
    {
        icon: Heart,
        title: "Friendly & jargon-free",
        body: "Clear explanations, honest advice, no upselling. Every car is treated like our own — daily driver or weekend toy.",
        accent: "text-safety bg-safety/10 border-safety/20",
    },
    {
        icon: Wrench,
        title: "Fair & transparent",
        body: "Live indicative ranges before you commit. No hidden fees and no surprises — your local repairer confirms the final price.",
        accent: "text-electric bg-electric/10 border-electric/20",
    },
    {
        icon: Shield,
        title: "Insurance approved",
        body: "Our repairers work with the major NZ insurers and can manage the claim end-to-end — paperwork and assessor visits included.",
        accent: "text-safety bg-safety/10 border-safety/20",
    },
];

const METRICS = [
    { icon: Zap, value: "15 sec", label: "to an AI estimate" },
    { icon: Clock, value: "24 hr", label: "typical match time" },
];

export default function WhyUs() {
    return (
        <section
            data-testid="why-us-section"
            className="relative py-20 md:py-28 bg-carbon overflow-hidden"
        >
            <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] bg-navy/30 rounded-full blur-[150px] pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-2xl mb-12 text-center mx-auto">
                    <p className="uppercase text-xs font-bold tracking-[0.3em] text-electric mb-3">
                        Why Panel Pros
                    </p>
                    <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
                        The smarter way to fix your car.
                    </h2>
                </div>

                {/* Metric chips */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-xl mx-auto">
                    {METRICS.map((m) => (
                        <div
                            key={m.label}
                            data-testid={`metric-${m.value}`}
                            className="glass rounded-2xl px-5 py-4 flex items-center gap-3"
                        >
                            <span className="w-10 h-10 rounded-xl bg-electric/10 grid place-items-center shrink-0">
                                <m.icon size={18} className="text-electric" />
                            </span>
                            <div>
                                <div className="font-display font-bold text-xl text-white leading-none">
                                    {m.value}
                                </div>
                                <div className="text-xs text-slate-400 mt-1">
                                    {m.label}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {PILLARS.map((p) => (
                        <div
                            key={p.title}
                            data-testid={`pillar-${p.title}`}
                            className="glass rounded-3xl p-7 md:p-8 hover:-translate-y-1.5 hover:border-white/20 transition-all duration-300 group"
                        >
                            <div
                                className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl border ${p.accent} group-hover:scale-105 transition-transform`}
                            >
                                <p.icon size={26} strokeWidth={2} />
                            </div>
                            <h3 className="font-display font-semibold text-xl text-white mt-5">
                                {p.title}
                            </h3>
                            <p className="text-slate-400 mt-3 text-sm leading-relaxed">
                                {p.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
